import {GET_CURRENT_PAGE, GET_CURRENT_ENV} from './actionTypes'

const initialState = {
  currentPage: '',
  currentEnv: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.currentPage,
        // fulfilled: true,
      }
    case GET_CURRENT_ENV:
      return {
        ...state,
        currentEnv: action.currentEnv,
      }
    default:
      return state
  }
};
